export const INCLUDE_MEDICAL_ABSTRACT = 'include_medical_abstract'

export default [INCLUDE_MEDICAL_ABSTRACT]
